import React, { createContext, useContext, useState } from "react";

// Global "Creator View" (creator-access users). Toggled from the top-nav Creator
// button. When ON, creator tools appear — e.g. per-template show/hide + text
// editing controls on the private Stories (Primary V1) page. Mirrors
// AdminModeContext / BusinessModeContext.
const Ctx = createContext(null);

export function CreatorModeProvider({ children }) {
    const [creatorMode, setCreatorMode] = useState(false);
    return (
        <Ctx.Provider value={{ creatorMode, setCreatorMode, toggle: () => setCreatorMode((v) => !v) }}>
            {children}
        </Ctx.Provider>
    );
}

export function useCreatorMode() {
    return useContext(Ctx) || { creatorMode: false, setCreatorMode: () => {}, toggle: () => {} };
}
